import styled from 'styled-components';
import { Layouts } from '~/shared';

export const AnimationWrapper = styled.div`
	&.${Layouts.VehiclePassport}-enter {
		.${Layouts.VehiclePassport}-background {
			opacity: 0;
		}

		.${Layouts.VehiclePassport} {
			opacity: 0;
		}
	}

	&.${Layouts.VehiclePassport}-enter-active,
		&.${Layouts.VehiclePassport}-enter-done,
		&.${Layouts.VehiclePassport}-exit {
		.${Layouts.VehiclePassport}-background {
			opacity: 1;
		}

		.${Layouts.VehiclePassport} {
			opacity: 1;
		}
	}

	&.${Layouts.VehiclePassport}-exit-active {
		.${Layouts.VehiclePassport}-background {
			opacity: 0;
		}

		.${Layouts.VehiclePassport} {
			opacity: 0;
		}
	}
`;
